import React, { useMemo, useState } from 'react';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const PriceCard = () => {
    const [annual, setAnnual] = useState(true);

    const plans = useMemo(
        () => [
            {
                id: 'starter',
                title: 'Starter Plan',
                subtitle: 'Freelancers, small websites',
                monthly: 12,
                yearly: 8,
                featureHeading: 'For small projects',
                features: [
                    'All Lite benefits',
                    '10,000+ premium template library',
                    'Personalized customization',
                    'Integration with 10+ design tool including Figma, Sketch, and Adobe XD',
                    'Enhanced regular updates',
                    'Perfect for growing teams',
                ],
                cta: 'Choose plan',
            },
            {
                id: 'pro',
                title: 'Professional Plan',
                subtitle: 'Growing businesses & SaaS platforms',
                monthly: 29,
                yearly: 20,
                featureHeading: 'For developing teams',
                features: [
                    'All Lite benefits',
                    '10,000+ premium template library',
                    'Personalized customization',
                    'Integration with 10+ design tool including Figma, Sketch, and Adobe XD',
                    'Enhanced regular updates',
                    'Perfect for growing teams',
                ],
                cta: 'Choose plan',
                popular: true, // center card
            },
            {
                id: 'enterprise',
                title: 'Enterprise Plan',
                subtitle: 'Large businesses or custom infrastructure needs',
                custom: true,
                featureHeading: 'For enterprises',
                features: [
                    'All Pro benefits',
                    'Unlimited template library',
                    'Advanced customization',
                    'Integration with 25+ design tool including Figma, Sketch, and Adobe XD',
                    'Real-time updates',
                    'Best for large teams and enterprises',
                ],
                cta: 'Choose plan',
            },
        ],
        []
    );

    const priceText = (p) => {
        if (p.custom) {
            return (
                <>
                    <span className="price-num">$00</span>
                    <span className="per">/Custom</span>
                </>
            );
        }
        const val = annual ? p.yearly : p.monthly;
        return (
            <>
                <span className="price-num">${val}</span>
                <span className="per">/Month</span>
            </>
        );
    };

    return (
        <section className="py-3 position-relative" style={{ overflow: 'hidden' }}>
            <div
                className="px-4 mx-auto position-relative"
                style={{ maxWidth: '74%', zIndex: 1, marginTop: -10 }}
            >
                {/* Toggle */}
                <div style={{ display: 'flex', justifyContent: 'center', margin: '12px 0 18px' }}>
                    <div
                        style={{
                            display: 'inline-flex',
                            gap: 8,
                            padding: 8,
                            background: '#ffffff',
                            border: '1px solid #e6eef9',
                            borderRadius: 999,
                            boxShadow: '0 8px 24px rgba(15,23,42,.06)',
                        }}
                    >
                        <button
                            onClick={() => setAnnual(false)}
                            className={`toggle-btn ${!annual ? 'active' : ''}`}
                            style={btnStyle(!annual)}
                        >
                            Monthly
                        </button>
                        <button
                            onClick={() => setAnnual(true)}
                            className={`toggle-btn ${annual ? 'active' : ''}`}
                            style={btnStyle(annual)}
                        >
                            Yearly <span style={{ marginLeft: 6, fontSize: 12, color: '#0b5bb6' }}>save ~20%</span>
                        </button>
                    </div>
                </div>

                {/* Cards */}
                <div className="pc-grid">
                    {plans.map((p) => (
                        <article key={p.id} className={`pc-card ${p.popular ? 'popular' : ''}`}>
                            {p.popular && <div className="pc-badge">Popular</div>}

                            <header>
                                <h3 className="pc-title">{p.title}</h3>
                                <p className="pc-sub">{p.subtitle}</p>
                            </header>

                            <div className="pc-price">{priceText(p)}</div>

                            {/* Heading + bullets under button */}
                            <div className="pc-features-heading">{p.featureHeading}</div>
                            <ul className="pc-features">
                                {p.features.map((f, i) => (
                                    <li key={i}>
                                        {p.popular ? (
                                            <IoMdCheckmarkCircleOutline className="pc-check" />
                                        ) : (
                                            <span className="pc-dot" aria-hidden />
                                        )}
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>

                            <button className="pc-cta">{p.cta}</button>
                        </article>
                    ))}
                </div>
            </div>

            {/* Styles */}
            <style>{`
  :root{
    --ink: #242121ff; 
    --muted: #413e3eff; 
    --card:#ffffff; 
    --stroke: #f4f9ffff; 
    --brand:#0A3D91;
    --grad1:#4FC3FF;
    --grad2:#2C2C6F;
  }

  .pc-grid{
    display:grid; 
    grid-template-columns: repeat(3, minmax(260px, 1fr)); /* narrower cards */
    gap:22px;
  }
  @media (max-width: 992px){ .pc-grid{grid-template-columns:1fr} }

  .pc-card{
    margin-top: 2rem;
    position:relative;
    background:var(--card);
    border-radius:16px;
    padding:22px 18px 24px;      
    min-height: 500px;                
    // box-shadow:0 6px 18px rgba(15,23,42,.05);
    border:1px solid var(--stroke);
    overflow:visible;
  }

  /* Center card: */
  .pc-card.popular{
    // box-shadow:0 12px 30px rgba(10,61,145,.16);
  }
  .pc-card.popular::before,
  .pc-card.popular::after{
    content:"";
    position:absolute;
    width:78px; height:78px;
    pointer-events:none;
  }
  .pc-card.popular::before{  /* top-right L */
    top:-1px; right:-1px;
    border-top-right-radius:16px;
    background:
      linear-gradient(to right, var(--grad1), var(--grad2)) top right / 78px 2px no-repeat,
      linear-gradient(to bottom, var(--grad1), var(--grad2)) top right / 2px 78px no-repeat;
    filter: drop-shadow(0 6px 14px rgba(79,195,255,.45));
  }
  .pc-card.popular::after{   /* bottom-left L */
    bottom:-1px; left:-1px;
    border-bottom-left-radius:16px;
    background:
      linear-gradient(to left, var(--grad1), var(--grad2)) bottom left / 78px 2px no-repeat,
      linear-gradient(to top,  var(--grad1), var(--grad2)) bottom left / 2px 78px no-repeat;
    filter: drop-shadow(0 6px 14px rgba(79,195,255,.45));
  }

  .pc-badge{
    position:absolute; 
    top:12px; 
    right:12px;
    background: linear-gradient(90deg, var(--grad1), var(--grad2));
    color:#fff; 
    font-size:12px; 
    padding:6px 10px; 
    border-radius:999px;
  }

  .pc-title{ 
     margin:0 0 4px; 
     font-size:20px;
     font-family: Lato; 
     line-height: 1.2;
     font-weight:600;
     color:var(--ink);
  }
  .pc-sub{ 
     margin:0; 
     color:var(--muted); 
     font-size:17px;
     font-weight:400;
     font-family: Lato;
     line-height: 1.2;
  }

  .pc-price{
    display:flex; 
    align-items:baseline; 
    gap:8px; 
    margin:10px 0 12px;
  }
  .price-num{
    font-size:34px; 
    font-weight:800; 
    letter-spacing:-.02em;
    background: linear-gradient(90deg, var(--grad1), var(--grad2));
    -webkit-background-clip:text; background-clip:text; color:transparent;
  }
  .per{ 
     color:var(--muted); 
     font-size:18px; 
     font-family:Lato, 
     font-weight:480; }

  /* Heading above bullets */
  .pc-features-heading{
    font-size:18px;
    font-family:  Lato, 
    line-height: 1.2;
    font-weight:650;
    color: #242121ff; 
    margin:8px 0 10px;
  }

  /* Bullets */
  .pc-features{ 
    list-style:none; 
    padding:0; 
    margin:0 0 16px; 
    display:grid; gap:12px 
}
  .pc-features li{ 
      display:flex; 
      gap:12px; 
      align-items:flex-start; 
      color:var(--muted); 
      font-size:16px; 
      font-family: Lato, 
      font-weight: 400;
      line-height:1.2 
    }
  /* hollow circle for card 1 & 3 */
  .pc-dot{
    position:relative;
    width:18px; height:18px;
    border-radius:50%;
    border:2px solid #bec3c9ff;
    background:#fff;
    flex-shrink:0;
    margin-top:2px;
  }
  /* center card check icon */
  .pc-check{
    font-size:18px;
    color: #b1b4b8ff;
    margin-top:2px;
    flex-shrink:0;
  }

  /* CTA button: filled gradient background */
  .pc-cta{
    width:70%;
    margin-left: 4rem;
    padding: 10px 12px;
    border-radius:12px;
    border:0;
    font-weight:600;
    cursor:pointer;
    background: linear-gradient(90deg, var(--grad1), var(--grad2));
    color:#ffffff;
    box-shadow: 0 6px 14px rgba(79,195,255,.25);
  }
  .pc-cta:hover{ filter: brightness(1.06) }

  .toggle-btn{
    font-weight:600;
    border:0;
    padding:10px 16px;
    border-radius:999px;
    cursor:pointer;
    background: transparent;
    color:#334155;
  }
  .toggle-btn:hover{ background:#f3f7ff }
  .toggle-btn:focus{ outline:none }
`}</style>
        </section>
    );
};

const btnStyle = (active) => ({
    border: 0,
    padding: '10px 16px',
    borderRadius: 999,
    fontWeight: 600,
    cursor: 'pointer',
    background: active ? 'linear-gradient(180deg,#f0f7ff,#e7f2ff)' : 'transparent',
    color: active ? '#0A3D91' : '#334155',
});

export default PriceCard;
